import { memo } from 'react'

import { SelectDropdownListItem } from '../../SelectDropdownListItem'
import { SelectDropdownEntityListItemContent } from '../SelectDropdownEntityListItemContent'

function SelectDropdownEntityListItem({
  Content = SelectDropdownEntityListItemContent,
  ref,
  ...restProps
}) {
  return <SelectDropdownListItem {...restProps} Content={Content} ref={ref} />
}

export default memo(SelectDropdownEntityListItem)
